import React from 'react';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

/**
 * A table column header that sorts by `field`. It is a real button inside the th, so it works from
 * the keyboard and announces its order through aria-sort. Inactive sortable columns show a muted
 * two-way arrow so you can see which columns sort.
 */
const SortableHeader = ({ field, sortField, sortDirection, onSort, align = '', className = '', title, children }) => {
  const active = sortField === field;
  const Arrow = !active ? ArrowUpDown : sortDirection === 'asc' ? ArrowUp : ArrowDown;
  return (
    <th
      className={`${align} ${className}`.trim()}
      title={title}
      aria-sort={active ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <button type="button" className="sort-button" onClick={() => onSort(field)}>
        {children}
        <Arrow size={12} className={active ? '' : 'sort-idle'} aria-hidden="true" />
      </button>
    </th>
  );
};

export default SortableHeader;
